import { create } from "zustand";

export interface TenantListState {
  /** 1-based page. */
  page: number;
  searchQuery: string;
  /** "" = All; otherwise a status value such as "active" | "inactive". */
  status: string;
  setPage: (page: number) => void;
  /** Also resets the page to 1. */
  setSearchQuery: (query: string) => void;
  /** Also resets the page to 1. */
  setStatus: (status: string) => void;
  reset: () => void;
}

const initialState = { page: 1, searchQuery: "", status: "" };

export const useTenantListStore = create<TenantListState>((set) => ({
  ...initialState,
  setPage: (page) => set({ page }),
  setSearchQuery: (searchQuery) => set({ searchQuery, page: 1 }),
  setStatus: (status) => set({ status, page: 1 }),
  reset: () => set({ ...initialState }),
}));
